<template>
  <div>
    <el-row>
      <h4><b>人员设置</b></h4>
      <el-radio-group v-model="dataType" @change="changeDataType">
        <el-radio label="INITIATOR">发起人</el-radio>
        <el-radio label="USERS">指定用户</el-radio>
        <el-radio label="ROLES">指定角色</el-radio>
      </el-radio-group>
    </el-row>
    <el-row>
      <div v-if="dataType === 'USERS'">
        <el-tag v-for="(userText,index) in selectedUser.text" :key="userText" effect="plain" @close="handleClose(index)" closable>
          {{userText}}
        </el-tag>
        <div class="element-drawer__button">
          <el-button size="mini" type="primary" icon="el-icon-plus" @click="onSelectUsers()">添加用户</el-button>
        </div>
      </div>
      <div v-if="dataType === 'ROLES'">
        <el-select v-model="roleIds" multiple size="mini" placeholder="请选择角色" @change="changeSelectRoles">
          <el-option
            v-for="item in roleOptions"
            :key="item.id"
            :label="item.roleName"
            :value="`ROLE${item.id}`"
            :disabled="item.status === 1">
          </el-option>
        </el-select>
      </div>
    </el-row>
    <el-row>
      <div v-show="showMultiFlog">
        <h4><b>多实例审批方式</b></h4>
        <el-row>
          <el-radio-group v-model="multiLoopType" @change="changeMultiLoopType()">
            <el-row><el-radio label="Null">无</el-radio></el-row>
            <el-row><el-radio label="SequentialMultiInstance">会签（需所有审批人同意）</el-radio></el-row>
            <el-row><el-radio label="ParallelMultiInstance">或签（一名审批人同意即可）</el-radio></el-row>
            <el-row><el-radio label="CustomMultiInstance">自定义会签条件</el-radio></el-row>
          </el-radio-group>
        </el-row>
        <el-row v-if="multiLoopType === 'CustomMultiInstance'">
          <el-input v-model="CustomCompletionCondition" clearable @change="updateLoopCondition" />
        </el-row>
        <el-row v-if="multiLoopType !== 'Null'">
          <el-tooltip content="开启后，实例需按顺序轮流审批" placement="top-start" @click.stop.prevent>
            <i class="header-icon el-icon-info"></i>
          </el-tooltip>
          <span class="custom-label">顺序审批：</span>
          <el-switch v-model="isSequential" @change="changeMultiLoopType()" />
        </el-row>
      </div>
    </el-row>

    <!-- 候选用户弹窗 -->
    <el-dialog title="候选用户" :visible.sync="userOpen" width="70%" append-to-body>
      <el-row :gutter="20">
        <div class="searchBox">
          <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <el-form-item label="用户名">
              <el-input v-model="dataForm.account" placeholder="模糊查询" clearable></el-input>
            </el-form-item>
            <el-form-item label="真实姓名">
              <el-input v-model="dataForm.realName" placeholder="模糊查询" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="getDataList()">查询</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div class="tableBox">
          <el-table :data="userTableList"
                    ref="multipleTable"
                    :row-class-name="tableRowClassName"
                    @row-click="rowClick"
                    :row-style="selectedHighlight"
                    @selection-change="selectionChangeHandle"
                    height="50vh"
                    border
                    size="small"
                    v-loading="dataListLoading"
                    style="width: 100%;">
            <el-table-column type="selection" width="40" fixed="left" align="center" />
            <el-table-column prop="account" align="center" label="用户名" />
            <el-table-column prop="realName" align="center" label="真实姓名" />
            <el-table-column prop="createTime" align="center" label="创建时间" />
            <el-table-column prop="status" width="60" fixed="right" align="center" label="状态">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status === 2" size="small" type="danger">禁用</el-tag>
                <el-tag v-else size="small">启用</el-tag>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
              :current-page="pageIndex"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleTaskUserComplete">确 定</el-button>
        <el-button @click="userOpen = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const userTaskForm = {
  dataType: '',
  assignee: '',
  candidateUsers: '',
  candidateGroups: '',
  text: '',
}

export default {
  name: "UserTask",
  props: {
    id: String,
    type: String
  },
  components: { },
  data() {
    return {
      loading: false,
      dataType: 'USERS',
      selectedUser: {
        ids: [],
        text: []
      },
      userOpen: false,
      deptName: undefined,
      deptOptions: [],
      deptProps: {
        children: "children",
        label: "label"
      },
      deptTempOptions: [],
      userTableList: [],
      userTotal: 0,
      deptTreeData: [],
      deptIds: [],
      // 查询参数
      queryParams: {
        deptId: undefined
      },
      showMultiFlog: false,
      isSequential: false,
      multiLoopType: 'Null',
      CustomCompletionCondition: '${nrOfCompletedInstances/nrOfInstances>=1}',

      // 用户视图
      selectedUserDate: [],
      dataListLoading: false,
      getIndex: -1,
      pageIndex: 1,
      pageSize: 20,
      totalPage: 0,
      dataForm: {
        account: null,
        realName: null,
        status: 1
      },

      // 角色视图
      roleOptions: [],
      roleIds: [],
    };
  },
  watch: {
    id: {
      immediate: true,
      handler() {
        this.bpmnElement = window.bpmnInstances.bpmnElement;
        this.$nextTick(() => this.resetTaskForm());
      }
    },
    // 根据名称筛选部门树
    deptName(val) {
      this.$refs.tree.filter(val);
    }
  },
  beforeDestroy() {
    this.bpmnElement = null;
  },
  methods: {
    resetTaskForm() {
      const bpmnElementObj = this.bpmnElement?.businessObject;
      if (!bpmnElementObj) {
        return;
      }
      this.clearOptionsData()
      this.dataType = bpmnElementObj['dataType'];
      if (this.dataType === 'USERS') {
        let userIdData = bpmnElementObj['candidateUsers'] || bpmnElementObj['assignee'];
        let userText = bpmnElementObj['text'] || [];
        if (userIdData && userIdData.toString().length > 0 && userText && userText.length > 0) {
          this.selectedUser.ids = userIdData?.toString().split(',');
          this.selectedUser.text = userText?.split(',');
        }
        if (this.selectedUser.ids.length > 1) {
          this.showMultiFlog = true;
        }
      }
      else if (this.dataType === 'ROLES') {
        this.getRoleOptions();
        let roleIdData = bpmnElementObj['candidateGroups'] || [];
        if (roleIdData && roleIdData.length > 0) {
          this.roleIds = roleIdData.split(',')
        }
        this.showMultiFlog = true;
      }
      this.getElementLoop(bpmnElementObj);
    },
    /**
     * 清空选项数据
     */
    clearOptionsData() {
      this.selectedUser.ids = [];
      this.selectedUser.text = [];
      this.roleIds = [];
      this.deptIds = [];
    },
    // 完成条件
    updateLoopCondition(condition) {
    },
    /**
     * 更新节点数据
     */
    updateElementTask() {
      const taskAttr = Object.create(null);
      for (let key in userTaskForm) {
          taskAttr[key] = userTaskForm[key];
      }
      window.bpmnInstances.modeling.updateProperties(this.bpmnElement, taskAttr);
    },
    changeSelectRoles(val) {
      let groups = null;
      let text = null;
      if (val && val.length > 0) {
        userTaskForm.dataType = 'ROLES';
        groups = val.join() || null;
        let textArr = this.roleOptions.filter(k => val.indexOf(`ROLE${k.roleId}`) >= 0);
        text = textArr?.map(k => k.roleName).join() || null;
      } else {
        userTaskForm.dataType = null;
        this.multiLoopType = 'Null';
      }
      userTaskForm.candidateGroups = groups;
      userTaskForm.text = text;
      this.updateElementTask();
      this.changeMultiLoopType();
    },
    changeDataType(val) {
      if (val === 'ROLES' || val === 'DEPTS' || (val === 'USERS' && this.selectedUser.ids.length > 1)) {
        this.showMultiFlog = true;
      } else {
        this.showMultiFlog = false;
      }
      this.multiLoopType = 'Null';
      this.changeMultiLoopType();
      // 清空 userTaskForm 所有属性值
      Object.keys(userTaskForm).forEach(key => userTaskForm[key] = null);
      userTaskForm.dataType = val;
      if (val === 'USERS') {
        if (this.selectedUser && this.selectedUser.ids && this.selectedUser.ids.length > 0) {
          if (this.selectedUser.ids.length === 1) {
            userTaskForm.assignee = this.selectedUser.ids[0];
          } else {
            userTaskForm.candidateUsers = this.selectedUser.ids.join()
          }
          userTaskForm.text = this.selectedUser.text?.join() || null
        }
      } else if (val === 'ROLES') {
        this.getRoleOptions();
        if (this.roleIds && this.roleIds.length > 0) {
          userTaskForm.candidateGroups = this.roleIds.join() || null;
          let textArr = this.roleOptions.filter(k => this.roleIds.indexOf(`ROLE${k.roleId}`) >= 0);
          userTaskForm.text = textArr?.map(k => k.roleName).join() || null;
        }
      } else if (val === 'DEPTS') {
        this.getDeptTreeData();
        if (this.deptIds && this.deptIds.length > 0) {
          userTaskForm.candidateGroups = this.deptIds.join() || null;
          let textArr = []
          let treeStarkData = JSON.parse(JSON.stringify(this.deptTreeData));
          this.deptIds.forEach(id => {
            let stark = []
            stark = stark.concat(treeStarkData);
            while(stark.length) {
              let temp = stark.shift();
              if(temp.children) {
                stark = temp.children.concat(stark);
              }
              if(id === temp.id) {
                textArr.push(temp);
              }
            }
          })
          userTaskForm.text = textArr?.map(k => k.label).join() || null;
        }
      } else if (val === 'MANAGER') {
        userTaskForm.assignee = "${DepManagerHandler.getUser(execution)}";
        userTaskForm.text = "部门经理";
      } else if (val === 'INITIATOR') {
        userTaskForm.assignee = "${initiator}";
        userTaskForm.text = "流程发起人";
      } else if (val === 'APPROVAL') {
        //userTaskForm.assignee = "${approval}";
        userTaskForm.assignee = "${getNextApprovalHandler.getApproval(execution)}";
        userTaskForm.text = "指定接收人";
      }
      this.updateElementTask();
    },
    getElementLoop(businessObject) {
      if (!businessObject.loopCharacteristics) {
        this.multiLoopType = "Null";
        return;
      }
      this.isSequential = businessObject.loopCharacteristics.isSequential;
      if (businessObject.loopCharacteristics.completionCondition) {
        if (businessObject.loopCharacteristics.completionCondition.body === "${nrOfCompletedInstances >= nrOfInstances}") {
          this.multiLoopType = "SequentialMultiInstance";
        } else if (businessObject.loopCharacteristics.completionCondition.body === "${nrOfCompletedInstances > 0}") {
          this.multiLoopType = "ParallelMultiInstance";
        } else {
          this.multiLoopType = "CustomMultiInstance";
        }
      }
    },
    changeMultiLoopType() {
      // 取消多实例配置
      if (this.multiLoopType === "Null") {
        window.bpmnInstances.modeling.updateProperties(this.bpmnElement, { loopCharacteristics: null, assignee: null });
        return;
      }
      this.multiLoopInstance = window.bpmnInstances.moddle.create("bpmn:MultiInstanceLoopCharacteristics", { isSequential: this.isSequential });
      // 更新多实例配置
      window.bpmnInstances.modeling.updateProperties(this.bpmnElement, {
        loopCharacteristics: this.multiLoopInstance,
        assignee: '${assignee}'
      });
      // 完成条件
      let completionCondition = null;
      // 会签
      if (this.multiLoopType === "SequentialMultiInstance") {
        completionCondition = window.bpmnInstances.moddle.create("bpmn:FormalExpression", { body: "${nrOfCompletedInstances >= nrOfInstances}" });
      }
      // 或签
      if (this.multiLoopType === "ParallelMultiInstance") {
        completionCondition = window.bpmnInstances.moddle.create("bpmn:FormalExpression", { body: "${nrOfCompletedInstances > 0}" });
      }
      // 自定义会签
      if (this.multiLoopType === "CustomMultiInstance") {
        completionCondition = window.bpmnInstances.moddle.create("bpmn:FormalExpression", { body: this.CustomCompletionCondition });
      }
      // 更新模块属性信息
      window.bpmnInstances.modeling.updateModdleProperties(this.bpmnElement, this.multiLoopInstance, {
        collection: '${multiInstanceHandler.getUserNames(execution)}',
        elementVariable: 'assignee',
        completionCondition
      });
    },


    // -------------- start用户视图 --------------
    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/system/user/findList'),
        method: 'get',
        params: this.$http.adornParams({
          'page': this.pageIndex,
          'limit': this.pageSize,
          'account': this.dataForm.account,
          'realName': this.dataForm.realName,
          'status': this.dataForm.status
        })
      }).then(({ data }) => {
        if (data) {
          this.userTableList = data.list
          this.totalPage = data.total
        } else {
          this.userTableList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    selectedHighlight ({ row, rowIndex }) {
      if ((this.getIndex) === rowIndex) {
        return {
          'background-color': 'rgb(250, 195, 100)'
        }
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      row.index = rowIndex
      if (row.status === 12) {
        return 'cancel-row'
      }
      return ''
    },
    rowClick (row) {
      this.getIndex = row.index
    },
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    selectionChangeHandle (val) {
      this.selectedUserDate = val
    },
    handleTaskUserComplete() {
      if (this.selectedUserDate || this.selectedUserDate.length > 0) {
        userTaskForm.dataType = 'USERS';
        this.selectedUser.text = this.selectedUserDate.map(k => k.account) || [];
        if (this.selectedUserDate.length === 1) {
          let data = this.selectedUserDate[0];
          userTaskForm.assignee = data.id;
          userTaskForm.text = data.account;
          userTaskForm.candidateUsers = null;
          this.showMultiFlog = false;
          this.multiLoopType = 'Null';
          this.changeMultiLoopType();
        } else {
          userTaskForm.candidateUsers = this.selectedUserDate.map(k => k.id).join() || null;
          userTaskForm.text = this.selectedUserDate.map(k => k.account).join() || null;
          userTaskForm.assignee = null;
          this.showMultiFlog = true;
        }
      }
      this.updateElementTask()
      this.userOpen = false;
    },
    handleClose(tag) {
      this.selectedUserDate.splice(tag, 1);
      this.handleTaskUserComplete()
    },
    onSelectUsers() {
      this.selectedUserDate = []
      this.$refs.multipleTable?.clearSelection()
      this.getDataList()
      this.userOpen = true;
    },
    // -------------- end用户视图 --------------

    // -------------- start角色视图 --------------
    getRoleOptions() {
      if (!this.roleOptions || this.roleOptions.length <= 0) {
        this.$http({
          url: this.$http.adornUrl('/system/role/findList'),
          method: 'get',
        }).then(({ data }) => {
          if (data && data.list.length > 0) {
            this.roleOptions = data.list
          } else {
            this.roleOptions = []
          }
        })
      }
    },
    // -------------- end角色视图 --------------
  }
};
</script>

<style scoped lang="scss">
.el-row .el-radio-group {
  margin-bottom: 15px;
  .el-radio {
    line-height: 28px;
  }
}
.el-tag {
  margin-bottom: 10px;
  + .el-tag {
    margin-left: 10px;
  }
}

.custom-label {
  padding-left: 5px;
  font-weight: 500;
  font-size: 14px;
  color: #606266;
}

</style>
